export default "__VITE_ASSET__4244f6b7__"